import React, { useState, useContext } from 'react';
import { ArrowLeftIcon, QrCodeIcon, TentIcon, DownloadIcon, CopyIcon, PercentIcon, CheckIcon, Share2Icon } from 'lucide-react';
import { FairContext } from '../../contexts/FairContext';
export function QRCodeGenerator({
  fair,
  onGenerated,
  onCancel
}) {
  const [qrSize, setQrSize] = useState(200);
  const [qrColor, setQrColor] = useState('#0066cc');
  const [isGenerated, setIsGenerated] = useState(false);
  const {
    setActiveFair
  } = useContext(FairContext);
  const handleGenerate = () => {
    // In a real app, this would generate a QR code with a specific URL
    // For this demo, we'll just simulate the generation
    setTimeout(() => {
      setIsGenerated(true);
    }, 1000);
  };
  const handleComplete = () => {
    // Update the fair to have an active QR code
    const updatedFair = {
      ...fair,
      hasQRCode: true
    };
    // Set this fair as the active fair with QR code
    setActiveFair(updatedFair);
    // Log to confirm the context is updated
    console.log('Setting active fair with QR code:', updatedFair);
    // Notify parent component
    onGenerated(fair.id);
  };
  return <div data-id="element-260" data-mp="2rbs628hkrk7z">
      <div className="flex justify-between items-center mb-6" data-id="element-261" data-mp="2r84e3drs35vd">
        <div className="flex items-center" data-id="element-262" data-mp="3525fkfa476zf">
          <button onClick={onCancel} className="mr-4 p-2 rounded-full bg-white/10 hover:bg-white/20 text-blue-300 transition-colors" data-id="element-263" data-mp="30anfrujtvcg1">
            <ArrowLeftIcon size={20} data-id="element-264" data-mp="3eyqm551s8q5d" />
          </button>
          <div data-id="element-265" data-mp="3f1cv994bndpp">
            <h2 className="text-2xl font-bold text-white flex items-center" data-id="element-266" data-mp="3a0p32k4cwqtw">
              <QrCodeIcon className="mr-2" size={24} data-id="element-267" data-mp="3a2t50wip3frj" />
              Generate QR Code for Fair
            </h2>
            <p className="text-blue-300 mt-1" data-id="element-268" data-mp="3jympr36kifke">
              Create a promotional QR code for {fair.name}
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-269" data-mp="1tmp4pdl5t98r">
        <div className="bg-white/5 backdrop-blur-sm border border-blue-800/30 rounded-xl p-6" data-id="element-270" data-mp="1plddx4qjuhyz">
          <h3 className="text-lg font-medium text-white mb-4" data-id="element-271" data-mp="3opv99fo7d3j7">Fair Details</h3>
          <div className="flex items-center mb-4" data-id="element-272" data-mp="3togejtibadei">
            <div className="w-12 h-12 bg-amber-900/30 rounded-full flex items-center justify-center border border-amber-700/30 mr-4" data-id="element-273" data-mp="3toyhta3e5rvx">
              <TentIcon className="h-6 w-6 text-amber-500" aria-hidden="true" data-id="element-274" data-mp="2khwmduspt1t" />
            </div>
            <div data-id="element-275" data-mp="7evm5zms15yk">
              <h4 className="text-white font-medium" data-id="element-276" data-mp="bj3ahvpbojw9">{fair.name}</h4>
              <p className="text-blue-300 text-sm" data-id="element-277" data-mp="bgqv9qay8nmw">{fair.location}</p>
            </div>
          </div>
          <div className="space-y-4 mt-6" data-id="element-278" data-mp="gftpsgtazbgm">
            <div data-id="element-279" data-mp="l8d3ddrzq6lf">
              <label className="block text-sm font-medium text-blue-300 mb-1" data-id="element-280" data-mp="l9xzv8xv7zlx">
                QR Code Size
              </label>
              <input type="range" min="150" max="300" step="10" value={qrSize} onChange={e => setQrSize(parseInt(e.target.value))} className="w-full h-2 bg-blue-900/50 rounded-lg appearance-none cursor-pointer" data-id="element-281" data-mp="q9sot6y2yf4c" />
              <div className="flex justify-between text-xs text-blue-400 mt-1" data-id="element-282" data-mp="z61ngje8h9pf">
                <span data-id="element-283" data-mp="2jrrmhh188ctl">Small</span>
                <span data-id="element-284" data-mp="2fp3d988lp3w3">Large</span>
              </div>
            </div>
            <div data-id="element-285" data-mp="2fqy390yqbm71">
              <label className="block text-sm font-medium text-blue-300 mb-1" data-id="element-286" data-mp="2apquaykuogys">
                QR Code Color
              </label>
              <div className="flex items-center space-x-3" data-id="element-287" data-mp="25rgz4nz4lgd6">
                <input type="color" value={qrColor} onChange={e => setQrColor(e.target.value)} className="h-8 w-8 rounded cursor-pointer" data-id="element-288" data-mp="25t0aq19u738m" />
                <span className="text-white" data-id="element-289" data-mp="2yge2zm2lbame">{qrColor}</span>
              </div>
            </div>
            {!isGenerated && <button onClick={handleGenerate} className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition-colors shadow-md flex items-center justify-center" data-id="element-290" data-mp="2tnbi02bvp9ht">
                <QrCodeIcon size={18} className="mr-2" data-id="element-291" data-mp="3m5ywv00a7sag" />
                Generate QR Code
              </button>}
          </div>
        </div>
        <div className="bg-white/5 backdrop-blur-sm border border-blue-800/30 rounded-xl p-6 flex flex-col items-center justify-center" data-id="element-292" data-mp="3hc47ph1wql3z">
          {isGenerated ? <div className="text-center" data-id="element-293" data-mp="35yu4j33osxle">
              <div className="mb-6 bg-white p-4 rounded-xl inline-block" data-id="element-294" data-mp="35vog7q2vtzqq">
                <QrCodeIcon size={qrSize} style={{
              color: qrColor
            }} data-id="element-295" data-mp="2rzkp45nb27ih" />
              </div>
              <div className="flex justify-center space-x-3 mb-6" data-id="element-296" data-mp="2wxcotlu6yxx8">
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-md flex items-center" data-id="element-297" data-mp="3knqbewu0c4kf">
                  <DownloadIcon size={18} className="mr-2" data-id="element-298" data-mp="3pnkzksmeeg1s" />
                  Download
                </button>
                <button className="bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg transition-colors flex items-center" data-id="element-299" data-mp="3fvysn8h3f34u">
                  <CopyIcon size={18} className="mr-2" data-id="element-300" data-mp="7f3zikq3kx3y" />
                  Copy
                </button>
              </div>
              <button onClick={handleComplete} className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg transition-colors shadow-md flex items-center justify-center" data-id="element-301" data-mp="c8gfk6gpnvl3">
                <CheckIcon size={18} className="mr-2" data-id="element-302" data-mp="1rxejugnbwt78" />
                Complete
              </button>
            </div> : <div className="text-center py-12" data-id="element-303" data-mp="25p2ra6mmuthv">
              <QrCodeIcon size={100} className="mx-auto text-blue-800/30 mb-4" data-id="element-304" data-mp="21o93dd96xeoz" />
              <h3 className="text-lg font-medium text-white mb-1" data-id="element-305" data-mp="1dyeut7vwmcaj">
                QR Code Preview
              </h3>
              <p className="text-blue-300" data-id="element-306" data-mp="18zlihiscsrby">
                Generate the QR code to see a preview
              </p>
            </div>}
        </div>
      </div>
      <div className="mt-6 bg-gradient-to-r from-purple-600/20 to-purple-700/20 backdrop-blur-sm border border-purple-500/30 rounded-xl p-5" data-id="element-307" data-mp="1n0eds5qhbqg4">
        <h3 className="text-lg font-bold text-white mb-3" data-id="element-308" data-mp="2ydql4qlg6r71">
          QR Code Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-309" data-mp="2tfopz7aqz1f7">
          <div className="bg-white/10 rounded-lg p-3 flex items-center" data-id="element-310" data-mp="2th9ot943h6iv">
            <PercentIcon size={20} className="text-green-400 mr-2" data-id="element-311" data-mp="1r190ca27zyie" />
            <div data-id="element-312" data-mp="1w02fe6x5nxko">
              <div className="text-sm text-white font-medium" data-id="element-313" data-mp="1vziwamvrr352">40% Discount</div>
              <div className="text-xs text-blue-300" data-id="element-314" data-mp="20279f6rimw7u">Automatically applied</div>
            </div>
          </div>
          <div className="bg-white/10 rounded-lg p-3 flex items-center" data-id="element-315" data-mp="250h137e17eop">
            <div size={20} className="text-blue-400 mr-2" data-id="element-316" data-mp="18bsztmqjc61z" />
            <div data-id="element-317" data-mp="1896iivduec6k">
              <div className="text-sm text-white font-medium" data-id="element-318" data-mp="1ccuqvgaatbsv">Kiosk Mode</div>
              <div className="text-xs text-blue-300" data-id="element-319" data-mp="1cas20zkvtopq">
                Optimized for displays
              </div>
            </div>
          </div>
          <div className="bg-white/10 rounded-lg p-3 flex items-center" data-id="element-320" data-mp="1m37g3lt25t5c">
            <Share2Icon size={20} className="text-purple-400 mr-2" data-id="element-321" data-mp="ona3ml743sds" />
            <div data-id="element-322" data-mp="on0f721ptta7">
              <div className="text-sm text-white font-medium" data-id="element-323" data-mp="olftm1xdpkoh">Shareable</div>
              <div className="text-xs text-blue-300" data-id="element-324" data-mp="tkk3yvw1hoge">Easy distribution</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}